var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCropped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "542.8165007112376 393.216 83.98293029871978 67.584",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    style: {
      maxHeight: 500
    },
    width: 83.98293029871978,
    height: 67.584,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n        stroke: url(#linear-gradient);\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 426.74,
    x2: 618.24,
    y1: 426.74,
    x1: 551.25,
    id: "linear-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcb05",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4d1d",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552.25,431.2h49.9l-14.41,14.41c-1.74,1.74-1.74,4.56,0,6.3,1.74,1.74,4.56,1.74,6.3,0l21.91-21.91c.9-.9,1.32-2.08,1.3-3.26.03-1.17-.4-2.36-1.3-3.26l-21.91-21.91c-1.74-1.74-4.56-1.74-6.3,0-1.74,1.74-1.74,4.56,0,6.3l14.41,14.41h-49.9",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCropped);
export default __webpack_public_path__ + "static/media/arrow-cropped.3fd483d587d8f3c03436fb0bf9234dad.svg";
export { ForwardRef as ReactComponent };